import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import React from "react";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import OngoingParticipationDrop from "./OngoingParticipationDrop";
import EndedParticipationDrop from "./EndedParticipationDrop";
import type { DropIdentityMode, DropInteractionParams, DropLocation, DropTimestampLayout } from "../drop.types";
interface DefaultParticipationDropProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly parentContainerRef?: React.RefObject<HTMLElement | null> | undefined;
  readonly footer?: React.ReactNode;
  readonly identityMode?: DropIdentityMode | undefined;
  readonly timestampLayout?: DropTimestampLayout | undefined;
  readonly showInteractions?: boolean | undefined;
  readonly winningThreshold?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export default function ParticipationDrop(props) {
  const $ = _c(6);
  const {
    drop,
    winningThreshold
  } = props;
  const {
    isVotingEnded
  } = useDropInteractionRules(drop);
  const hasWinningThreshold = typeof winningThreshold === "number" && Number.isFinite(winningThreshold) && winningThreshold > 0;
  if (isVotingEnded) {
    if (hasWinningThreshold) {
      let t0;
      if ($[0] !== props) {
        t0 = <OngoingParticipationDrop {...props} isVotingClosed={true} />;
        $[0] = props;
        $[1] = t0;
      } else {
        t0 = $[1];
      }
      return t0;
    }
    let t0;
    if ($[2] !== props) {
      t0 = <EndedParticipationDrop {...props} />;
      $[2] = props;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  let t0;
  if ($[4] !== props) {
    t0 = <OngoingParticipationDrop {...props} />;
    $[4] = props;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}